export default "__VITE_ASSET__B7N8_VV8__"